import React from 'react'
import MetodyWyceny from './MetodyWyceny'
import UstalenieWynikuFinansowego from './UstalenieWynikuFinansowego'
import UstalenieSposobuSporzadzenia from './UstalenieSposobuSporzadzenia'
import PolitykaRachunkowosciPozostale from './PolitykaRachunkowosciPozostale'

export default function PolitykaRachunkowosciV12(props) {
  return (
    <>
      <div className="section_header high-emphasis-subtitle-1">
        OMÓWIENIE PRZYJĘTYCH ZASAD (POLITYKI) RACHUNKOWOŚCI, W ZAKRESIE W JAKIM
        USTAWA POZOSTAWIA JEDNOSTCE PRAWO WYBORU, W TYM:
      </div>
      <MetodyWyceny
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieWynikuFinansowego
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieSposobuSporzadzenia
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <PolitykaRachunkowosciPozostale
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
    </>
  )
}
